module.exports = __webpack_public_path__ + "static/img/journal_test.1784115679763.png";